// @flow

import React, {Component} from 'react';
import {connect} from 'react-redux';
import AdminList from '../../components/AdminList/AdminList';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import {fetchFilters, fetchData} from '../../actions/exportsView';
import SelectFormInput from '../../components/SelectFormInput/SelectFormInput';
import {assortments} from '../../assortments';
import _ from 'lodash/fp';

const columns = [{
  property: 'product',
  header: {
    label: 'Produkt',
  },
}, {
  property: 'variant',
  header: {
    label: 'Variant',
  },
}, {
  property: 'itemNumber',
  header: {
    label: 'Internt artikelnummer',
  },
}, {
  property: 'externalItemNumber',
  header: {
    label: 'Externt artikelnummer',
  },
}, {
  property: 'quantity',
  header: {
    label: 'Antal',
  },
}, {
  property: 'price',
  header: {
    label: 'Pris totalt',
  },
}];

export type Props = {
  isFetching: boolean,
  fetchFilters: Function,
  fetchData: Function,
  currentSelection: Object,
  filters: Object,
  isProjectSelected: boolean,
};

class ExportsContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    this.props.fetchFilters();
  }

  render() {
    const {
      isFetching,
      filters,
      currentSelection,
      fetchData,
      isProjectSelected,
    } = this.props;

    return (
      <div className="ExportsContainer relative">
        <LoadingIndicator isLoading={isFetching} />
        <div className="row align-middle">
          <div className="column">
            <SelectFormInput
              input={{
                value: currentSelection.projects,
                onBlur: _.noop,
                onChange: val => fetchData({...currentSelection, projects: val}),
              }}
              label="Projekt"
              placeholder="Välj projekt"
              meta={{}}
              valueKey="id"
              labelKey="name"
              multi={true}
              options={filters.projects}
              clearable={false}
              isLoading={false} />
          </div>
          <div className="column">
            <SelectFormInput
              input={{
                value: currentSelection.suppliers,
                onBlur: _.noop,
                onChange: val => fetchData({...currentSelection, suppliers: val}),
              }}
              label="Leverantörer"
              placeholder="Alla"
              meta={{}}
              valueKey="id"
              labelKey="name"
              clearable={true}
              multi={true}
              disabled={!isProjectSelected}
              options={filters.suppliers}
              isLoading={false} />
          </div>
          <div className="column">
            <SelectFormInput
              input={{
                value: currentSelection.workerTypes,
                onBlur: _.noop,
                onChange: val => fetchData({...currentSelection, workerTypes: val}),
              }}
              label="Yrkeskategori"
              placeholder="Alla"
              meta={{}}
              valueKey="id"
              labelKey="name"
              clearable={true}
              multi={true}
              disabled={!isProjectSelected}
              options={filters.workerTypes}
              isLoading={false} />
          </div>
        </div>
        <div className="row align-middle">
          <div className="column">
            <SelectFormInput
              input={{
                value: currentSelection.roomTypes,
                onBlur: _.noop,
                onChange: val => fetchData({...currentSelection, roomTypes: val}),
              }}
              label="Rumstyp"
              placeholder="Alla"
              meta={{}}
              valueKey="id"
              labelKey="name"
              clearable={true}
              multi={true}
              disabled={!isProjectSelected}
              options={filters.roomTypes}
              isLoading={false} />
          </div>
          <div className="column">
            <SelectFormInput
              input={{
                value: currentSelection.productTypes,
                onBlur: _.noop,
                onChange: val => fetchData({...currentSelection, productTypes: val}),
              }}
              label="Produkttyp"
              placeholder="Alla"
              meta={{}}
              valueKey="id"
              labelKey="name"
              clearable={true}
              multi={true}
              disabled={!isProjectSelected}
              options={filters.productTypes}
              isLoading={false} />
          </div>
          <div className="column">
            <SelectFormInput
              input={{
                value: currentSelection.assortments,
                onBlur: _.noop,
                onChange: val => fetchData({...currentSelection, assortments: val}),
              }}
              label="Sortiment"
              placeholder="Alla"
              meta={{}}
              valueKey="id"
              labelKey="label"
              multi={true}
              disabled={!isProjectSelected}
              options={[assortments[0], assortments[2]]}
              clearable={true}
              isLoading={false} />
          </div>
        </div>
        <div className="row align-right">
          <div className="column shrink">
            {currentSelection.rows.length > 0 && currentSelection.downloadUri && <a
              href={currentSelection.downloadUri}
              target="_blank"
              className="button success">
              Ladda ner
            </a>}
          </div>
        </div>
        <div className="box">
          <AdminList
            columns={columns}
            footer={[...Array(4), currentSelection.totalQuantity, currentSelection.totalPrice]}
            rows={currentSelection.rows}
            rowKey='itemNumber'
            pagination={false} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  exportsView: {
    filterOptions,
    currentSelection,
  },
}) => ({
  isFetching: filterOptions.isFetching || currentSelection.isFetching,
  isProjectSelected: currentSelection.projects !== null && currentSelection.projects.length > 0,
  filters: filterOptions,
  currentSelection,
});

const mapDispatchToProps = dispatch => ({
  fetchFilters: () =>
    dispatch(fetchFilters()),
  fetchData: filters =>
    dispatch(fetchData(filters)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportsContainer);



// WEBPACK FOOTER //
// ./src/containers/ExportsContainer/ExportsContainer.js